import { NgOptimizedImage } from '@angular/common';
import { Component, DestroyRef, inject, type OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

import { DISABLED_REASON } from '@core/models/onboarding.model';

import {
  BASIC_RESTRICTED_ACCESS_DATA,
  type IRestrictedAccessData,
  NOT_SELECTED_FOR_ASSESSMENT_RESTRICTED_ACCESS_DATA,
  UNDER_CONSTRUCTION_RESTRICTED_ACCESS_DATA,
} from './helpers';

@Component({
  selector: 'ume-restricted-access',
  templateUrl: './restricted-access.component.html',
  styleUrls: ['./restricted-access.component.scss'],
  imports: [NgOptimizedImage],
})
export class RestrictedAccessComponent implements OnInit {
  public readonly _destroyRef = inject(DestroyRef);
  public readonly _route: ActivatedRoute = inject(ActivatedRoute);

  public pageData: IRestrictedAccessData = BASIC_RESTRICTED_ACCESS_DATA;

  public ngOnInit(): void {
    this._route.queryParams.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((params) => {
      if (params.disabledReason) {
        this._setData(params.disabledReason);
      }
    });
  }

  private _setData(disabledReason: string): void {
    switch (disabledReason) {
      case DISABLED_REASON.NOT_SELECTED_FOR_ASSESSMENT:
        this.pageData = NOT_SELECTED_FOR_ASSESSMENT_RESTRICTED_ACCESS_DATA;
        return;
      case DISABLED_REASON.UNDER_CONSTRUCTION:
        this.pageData = UNDER_CONSTRUCTION_RESTRICTED_ACCESS_DATA;
        return;
      default:
        this.pageData = BASIC_RESTRICTED_ACCESS_DATA;
        return;
    }
  }
}
